import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { getPhoneMaskByCountry } from '~/shared/config/countryConfig'
import { MaskInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type ContactsProps = {
  isLoading: boolean
  disabled: boolean
}

export function Contacts({ isLoading, disabled }: ContactsProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('contacts')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={12}>
          <MaskInput
            label='form.phone'
            name='phone_number'
            skeletonShow={isLoading}
            readOnly={disabled}
            mask={getPhoneMaskByCountry()}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.E-mail'
            name='email'
            type='email'
            readOnly={disabled}
            skeletonShow={isLoading}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.website'
            name='web_site'
            skeletonShow={isLoading}
            readOnly={disabled}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.main settlement account'
            name='main_checking_account'
            readOnly={disabled}
            skeletonShow={isLoading}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.legal address'
            name='legal_address'
            readOnly={disabled}
            skeletonShow={isLoading}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.actual address'
            name='actual_address'
            readOnly={disabled}
            skeletonShow={isLoading}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
